import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const StartHere = () => {
  const steps = [
    {
      title: 'O que é Bitcoin?',
      description: 'Entenda os fundamentos do Bitcoin: uma moeda digital descentralizada que não depende de governos ou bancos centrais.',
      topics: [
        'História e origem do Bitcoin',
        'Como funciona a tecnologia blockchain',
        'Diferença entre Bitcoin e outras criptomoedas',
        'Por que o Bitcoin é importante'
      ]
    },
    {
      title: 'Por que Bitcoin importa?',
      description: 'Descubra como o Bitcoin está revolucionando o sistema financeiro global e promovendo soberania financeira.',
      topics: [
        'Liberdade financeira e censura',
        'Proteção contra inflação',
        'Inclusão financeira global',
        'Separação de dinheiro e Estado'
      ]
    },
    {
      title: 'Como comprar Bitcoin',
      description: 'Aprenda as diferentes formas de adquirir Bitcoin de maneira segura.',
      topics: [
        'Exchanges centralizadas (CEX)',
        'Plataformas peer-to-peer (P2P)',
        'Compra sem KYC',
        'Métodos de pagamento disponíveis'
      ]
    },
    {
      title: 'Como armazenar Bitcoin com segurança',
      description: 'A parte mais importante: aprenda a manter seus Bitcoin seguros através da autocustódia.',
      topics: [
        'Diferença entre custódia e autocustódia',
        'Carteiras de software (hot wallets)',
        'Carteiras de hardware (cold wallets)',
        'Backup e recuperação de seed phrases'
      ]
    },
    {
      title: 'Melhores práticas de segurança',
      description: 'Proteja seus Bitcoin com medidas de segurança essenciais.',
      topics: [
        'Nunca compartilhe suas chaves privadas',
        'Use autenticação de dois fatores (2FA)',
        'Verifique endereços antes de enviar',
        'Evite golpes e phishing'
      ]
    },
    {
      title: 'Introdução à Lightning Network',
      description: 'Conheça a segunda camada do Bitcoin que permite transações instantâneas e baratas.',
      topics: [
        'O que é Lightning Network',
        'Como abrir canais de pagamento',
        'Carteiras Lightning recomendadas',
        'Casos de uso práticos'
      ]
    }
  ];

  return (
    <div className="min-h-screen py-16" data-testid="start-here-page">
      <div className="max-w-4xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
            Comece Aqui
          </h1>
          <p className="text-lg md:text-xl leading-relaxed text-muted-foreground">
            Seu guia passo a passo para começar sua jornada no mundo do Bitcoin
          </p>
        </div>

        <div className="space-y-12">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-sm p-8"
              data-testid={`step-${index + 1}`}
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-primary-foreground font-bold text-xl flex-shrink-0">
                  {index + 1}
                </div>
                <div className="flex-1">
                  <h2 className="text-2xl font-bold mb-3">{step.title}</h2>
                  <p className="text-muted-foreground mb-4">{step.description}</p>
                  <ul className="space-y-2">
                    {step.topics.map((topic, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <CheckCircle2 className="text-primary mt-1 flex-shrink-0" size={18} />
                        <span>{topic}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-primary/10 border-2 border-primary rounded-sm p-8 text-center">
          <h3 className="text-2xl font-bold mb-4">Pronto para começar?</h3>
          <p className="text-muted-foreground mb-6">
            Explore nossos tutoriais detalhados e artigos educacionais para aprofundar seu conhecimento.
          </p>
          <div className="flex gap-4 justify-center">
            <Link to="/tutoriais">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="explore-tutorials-button">
                Ver Tutoriais
              </Button>
            </Link>
            <Link to="/artigos">
              <Button variant="secondary" data-testid="explore-articles-button">
                Ler Artigos
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartHere;